export default "__VITE_ASSET__B3iMFpG5__"